import { FilterType } from '@src/app/shared/components/table-filter/table-filter.component';
import { Column } from '@src/app/shared/services/table.setting.service';
import { FiltersPanelChangeEvent, FiltersPanelBackendFilter } from '@src/app/shared/components/filters-panel/filters-panel.models';

export function getPanelManagedPropertyNames(columns: Column[]): Set<string> {
  const managedPropertyNames = new Set<string>();

  const safeColumns = Array.isArray(columns) ? columns : [];

  for (const column of safeColumns) {
    if (!column) {
      continue;
    }

    const columnField = (column.field ?? '').toLowerCase();

    if (columnField === 'actions') {
      continue;
    }

    // Supports nested filterField like "item.serialNumber"
    const backendFieldKey = column.filterField ?? column.field;

    if (!backendFieldKey) {
      continue;
    }

    const baseFilterType = column.filter;
    const panelOverrideType = column.panelFilter;

    const isText = baseFilterType === FilterType.Text;
    const isDate = baseFilterType === FilterType.Date;
    const isCustomDropdown = (panelOverrideType === FilterType.CustomDropdown);
    const isNumber = baseFilterType === FilterType.Numeric;

    if (isText || isDate || isNumber) {
      managedPropertyNames.add(backendFieldKey);
      continue;
    }

    if (isCustomDropdown) {
      managedPropertyNames.add(backendFieldKey);
      continue;
    }
  }

  return managedPropertyNames;
}

export function applyFiltersPanelChange(
  evt: FiltersPanelChangeEvent,
  currentFilters: FiltersPanelBackendFilter[],
  columns: Column[]
): FiltersPanelBackendFilter[] | null {
  if (!evt) {
    return null;
  }

  const incomingFilters = Array.isArray(evt.filters) ? evt.filters : [];
  const hasIncomingFilters = incomingFilters.length > 0;

  const isRestoreEvent = evt.source === 'restore';

  if (isRestoreEvent && !hasIncomingFilters) {
    return null;
  }

  const managedPropertyNames = getPanelManagedPropertyNames(columns);

  const safeCurrentFilters = Array.isArray(currentFilters) ? currentFilters : [];
  const nextFilters: FiltersPanelBackendFilter[] = [];

  // 1) Keep existing filters that are NOT managed by the panel
  for (const existing of safeCurrentFilters) {
    if (!existing) {
      continue;
    }

    const propertyName = existing.propertyName;

    // if smth is malformed, keep it rather than risk deleting it
    if (!propertyName) {
      nextFilters.push(existing);
      continue;
    }

    const isManagedByPanel = managedPropertyNames.has(propertyName);

    if (!isManagedByPanel) {
      nextFilters.push(existing);
    }
  }

  // 2) Add the incoming filters from the panel
  for (const incoming of incomingFilters) {
    nextFilters.push({
      propertyName: incoming.propertyName,
      operator: incoming.operator,
      values: incoming.values
    });
  }

  return nextFilters;
}
